// extracted by mini-css-extract-plugin
export default {"greenBadge":"payment_greenBadge__6ZJ0z","infoBadge":"payment_infoBadge__c-JCO","dangerBadge":"payment_dangerBadge__cuhiA"};